<template>
    <div>
        <template v-if="isArrayValue">
            <ul class="list-style m-0">
                <li class=""
                    v-for="(_val, _index) in value"
                    :key="`${parentKeyBind}-value-${_index}`">
                    <template v-if="isObject(_val)">
                        <table>
                            <tr v-for="(cValue, cProperty, cIndex) in _val"
                                :key="`${parentKeyBind}-value-${_index}-child-${cIndex}`">
                                <td>{{ cProperty }}</td>
                                <td>{{ cValue }}</td>
                            </tr>
                        </table>
                    </template>
                    <template v-else>
                        {{ _val }}
                    </template>
                </li>
            </ul>
        </template>
        <template v-else-if="isObjectValue">
            <table>
                <tr v-for="(_val, _property, _index) in value"
                    :key="`${parentKeyBind}-value-${_index}`">
                    <td>{{ _property }}</td>
                    <td>{{ _val }}</td>
                </tr>
            </table>
        </template>
        <template v-else>
            {{ value }}
        </template>
    </div>
</template>

<script>
import {isArray, isObject} from '@config/utils';

export default {
	name: 'ValueAudit',
	props: {
        value: {
            default: null
        },
        parentKeyBind: {
            type: String,
            default: null
        },
	},
	data() {
		return {

		}
	},
	mounted() {
    },
	computed: {
        isArrayValue() {
            return isArray(this.value);
        },
        isObjectValue() {
            return isObject(this.value);
        }
	},
	methods: {
        isObject(a) {
            return isObject(a);
        }
	},
}
</script>

<style scoped lang="scss">
</style>